import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-component" }
const _hoisted_2 = {
  class: "p-input-icon-left",
  style: {"width":"50vh"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-magnifying-glass" })
], -1 /* HOISTED */)

import { onMounted } from 'vue';
import { ref } from 'vue';
import { useStore } from 'vuex';

import { useEmitter } from '@rednex/gateway_core';
//--- Function imports

//### Service imports
//--- Service imports

//### Model imports
//--- Model imports

//### Component imports
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

//### Function imports
const emitter = useEmitter();
const store = useStore();
//--- Setup

//### Store/Reactive Data
//--- Store/Reactive Data

//### Variables const let
const searchText = ref('');
const isLoading = ref(false);
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
  searchText.value = store.getters.searchTxt;
});
//--- Component Lifecycle

//### Functions
function searchClicked() {
  isLoading.value = true;
  store.commit('setSearchTxt', searchText.value);
  emitter.emit('list-search-clicked');
  isLoading.value = false;
}

function showExtendedSearchClicked() {
  store.commit('setExtendedSearchComponentVisible', !store.getters.extendedSearchComponentVisible);
}
//--- Functions

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputText, {
        style: {"width":"100%"},
        type: "text",
        modelValue: searchText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
        placeholder: _ctx.$t('global.search'),
        disabled: _unref(store).getters.extendedSearchComponentVisible,
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchClicked()), ["enter"]))
      }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled"])
    ]),
    _createVNode(_component_Button, {
      icon: "fa fa-magnifying-glass",
      loading: isLoading.value,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (searchClicked())),
      disabled: _unref(store).getters.extendedSearchComponentVisible || isLoading.value
    }, null, 8 /* PROPS */, ["loading", "disabled"]),
    (_unref(store).getters.extendedSearchComponentVisible)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          icon: "fa fa-magnifying-glass-minus",
          onClick: showExtendedSearchClicked
        }))
      : _createCommentVNode("v-if", true),
    (!_unref(store).getters.extendedSearchComponentVisible)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          icon: "fa fa-magnifying-glass-plus",
          onClick: showExtendedSearchClicked
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})